var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaret = function SvgCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M128 182a5.8 5.8 0 0 1-4.2-1.8l-80-80a5.9 5.9 0 0 1 8.4-8.4l75.8 75.7 75.8-75.7a5.9 5.9 0 0 1 8.4 8.4l-80 80a5.8 5.8 0 0 1-4.2 1.8"
  })));
};
export default SvgCaret;